var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9992 16C31.9992 24.8367 24.8359 32 15.9992 32C7.16328 31.9992 0 24.8359 0 16C0 7.16328 7.16328 0 16 0C24.8367 0 32 7.16328 32 16H31.9992Z",
    fill: "#333D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7407 14.7588L20.4741 16.8993C20.429 17.2569 20.1262 17.5258 19.767 17.5258H16.3001V26.4753C15.9345 26.5083 15.5641 26.5252 15.1896 26.5252C14.3521 26.5252 13.5347 26.4415 12.7447 26.282V17.5258H10.0783C9.83347 17.5258 9.63375 17.3253 9.63375 17.0797V14.4012C9.63375 14.1556 9.83347 13.9551 10.0783 13.9551H12.7447V9.93815C12.7447 7.47308 14.7346 5.4751 17.19 5.4751H20.301C20.5458 5.4751 20.7455 5.67562 20.7455 5.92124V8.59972C20.7455 8.84534 20.5458 9.04586 20.301 9.04586H18.0783C17.0966 9.04586 16.301 9.84474 16.301 10.8312V13.9559H20.0344C20.4628 13.9559 20.7938 14.3328 20.7415 14.7596L20.7407 14.7588Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.edcae08fd20072fc402e5968226b09b4.svg";
export { ForwardRef as ReactComponent };